export const mprConstants = {
  MPR_SUCCESS: 'MPR_SUCCESS',
  MPR_FAILURE: 'MPR_FAILURE',
  MPR_DATA_SUCCESS: 'MPR_DATA_SUCCESS',
  MPR_DATA_FAILURE: 'MPR_DATA_FAILURE',
};
